/*
 * TODO
 * refactor this page into components
 */
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { asyncConnect } from 'redux-async-connect'
import CSSModules from 'react-css-modules'
import { chain } from 'lodash'
import moment from 'moment'
import Loader from 'react-loader'
import chroma from 'chroma-js'
import ReactTooltip from 'react-tooltip'
import {SlideDown} from 'react-slidedown'
import {Row, Col} from 'react-flexbox-grid'
import config from '../../config'
import format from '../../helpers/format'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import {
  ContainerDivs,
  CompanyProfileModal,
  Chart,
  FlaggedFund,
  Link,
  LinkIcon,
  Tweeter,
  FundName,
  FundShareTakeAction,
  InlineSignup,
  IyvScorecard,
  Grade,
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './FundPrisonInvestments.css'


const FirstPage = 5
const AllPage = 1000000

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

function filterHoldings(fHoldingsMap, holdings, filterFn){
  return chain(holdings)
  .filter(filterFn)
  .sortBy((o)=>{
    return fHoldingsMap[o.id].market_value * -1
  })
  // .take(10)
  .value()
}

//
//
// COMPONENTS FOR THIS PAGE

/*
 * ICONS AND IMAGES
 */
@CSSModules(Styles, {allowMultiple:true})
class LoadingIcon extends Component {
  render() {
    return <div styleName='main'>
      <Loader
        options={{scale: 0.70, top:'2.0rem'}}
        loaded={false}
      />
    </div>
  }
}

@CSSModules(Styles, {allowMultiple:true})
class HighRiskIcon extends Component {
  render() {
    return <span styleName='holding-name-high-icon'>
      <LinkIcon faclass='fa-exclamation-triangle' nospace/>
    </span>
  }
}

@CSSModules(Styles, {allowMultiple:true})
class ExtremeRiskIcon extends Component {
  render() {
    return <span styleName='holding-name-extreme-icon'>
      <LinkIcon faclass='fa-exclamation-triangle' nospace/>
    </span>
  }
}


/*
 * ALERTS
 *
 * ALERT: FUND HAS NO PRISON OR BORDER HOLDINGS. GRADE A
 */
@CSSModules(Styles, {allowMultiple:true})
class NoFlaggedHoldingsAlert extends Component {
  render() {
    return (
      <div styleName='flagged-fund-clean-title'>
        No investments flagged.
      </div>
    )
  }
}

/*
 * ALERT: FUND HAS PRISON OR BORDER HOLDINGS. SHOW SUMMARY TOTALS
 */
@CSSModules(Styles, {allowMultiple:true})
class FlaggedHoldingsAlert extends Component {
  static propTypes = {
    a: PropTypes.string.isRequired,
    b: PropTypes.string.isRequired,
    c: PropTypes.string.isRequired,
    d: PropTypes.string.isRequired,
    e: PropTypes.string.isRequired,
    f: PropTypes.string.isRequired,
  }
  constructor(props) {
    super(props)
    
    const high_style = (props.c !== '$0') ? 'fund-totals--high' : ''
    const extreme_style = (props.e !== '$0') ? 'fund-totals--extreme' : ''

    this.state = {
      high_style,
      extreme_style,
    }
  }

  //
  render() {
    return (
      <div styleName='fund-totals'>
        <div styleName='fund-totals__row'>
          <div styleName='fund-totals__cell'>
            <div styleName='fund-totals__label'>
              Flagged investments
            </div>
            <div styleName='fund-totals__asset'>
              {this.props.a}
            </div>
            <div styleName='fund-totals__weight'>
              {this.props.b} of assets
            </div>
          </div>
          <div styleName={'fund-totals__cell '+this.state.high_style}>
            <div styleName='fund-totals__label'>
              High Risk
            </div>
            <div styleName='fund-totals__asset'>
              {this.props.c}
            </div>
            <div styleName='fund-totals__weight'>
              {this.props.d} of assets
            </div>
          </div>
          <div styleName={'fund-totals__cell '+this.state.extreme_style}>
            <div styleName='fund-totals__label'>
              Private prison operators
            </div>
            <div styleName='fund-totals__asset'>
              {this.props.e}
            </div>
            <div styleName='fund-totals__weight'>
              {this.props.f} of assets
            </div>
          </div>
        </div>
      </div>
    )
  }
}

{ /* <div styleName='fam-tots'>

  <div styleName='fam-tot'>
    Flagged investments:
  </div>
  <div styleName='fam-tot-val'>
    {this.props.a}, {this.props.b} of assets
  </div>
  <div styleName='fam-tot'>
    <HighRiskIcon />
    &nbsp;
    <strong>Higher risk:</strong>
  </div>
  <div styleName='fam-tot-val'>
    {this.props.c}, {this.props.d} of assets
  </div>
  <div styleName='fam-tot'>
    <ExtremeRiskIcon />
    &nbsp;
    <span styleName='bred'>
      Private prison operators:
    </span>
  </div>
  <div styleName='fam-tot-val'>
    {this.props.e}, {this.props.f} of assets
  </div>
</div> */ }

/*
 * ALERT: FUND HAS NO PRISON OR BORDER HOLDINGS. CHECK OUT TOOLKIT
 */
@CSSModules(Styles, {allowMultiple:true})
class ToolkitAlert extends Component {
  render() {
    return <div styleName='clean-funds-link'>
      <div styleName='clean-funds-headline'>
        Want to learn how to add prison free funds to your
        retirement plan?
      </div>
      <div styleName='clean-funds-info'>
        Use our Action Toolkit and get started moving your money.
      </div>
      <div styleName='clean-funds-btn-wrap'>
        <Link
          to={config.routes.toolkit}
          roundbutton
          title='Action toolkit'
        >
          Action toolkit<LinkIcon />
        </Link>
      </div>
    </div>
  }
}

/*
 * ALERT: GRADE BOX: SHOWS GRADE + DESCRIPTIVE TEXT
 */
@CSSModules(Styles, {allowMultiple:true})
class PrisonGradeBox extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
  }
  //
  constructor(props) {
    super(props)

    const numberGrade = props.fund.grade_prison_industrial_complex
    const letterGrade = format.score(numberGrade)
    const sfGrade = letterGrade === 'N/A' ? 'NA' : letterGrade

    const fGradeDescriber = (x) => {
      if (convert.int(props.fund.pff_all_extreme_count)) {
        return (<span>One or more holdings were flagged as <span styleName='bred'>private prison operators</span> by our prison industrial complex screen. Assigned a grade of F.</span>)
      } else {
        return (<span>One or more holdings were flagged as <strong>higher risk</strong> by our prison industrial complex screen, making up over 2% of the portfolio. Assigned a grade of F.</span>)
      }
    }

    const descriptions = {
      A: 'No holdings flagged by our prison industrial complex screen. Assigned a grade of A.',
      B: (<span>One or more holdings were flagged by our prison industrial complex screen, but there were no <strong>higher risk</strong> companies in the portfolio. Assigned a grade of B.</span>),
      C: (<span>One or more holdings were flagged as <strong>higher risk</strong> by our prison industrial complex screen, making up less than 1% of the portfolio. Assigned a grade of C.</span>),
      D: (<span>One or more holdings were flagged as <strong>higher risk</strong> by our prison industrial complex screen, making up between 1% and 2% of the portfolio. Assigned a grade of D.</span>),
      F: fGradeDescriber(),
      NA: 'Error',
    }
    const description = descriptions[sfGrade]

    this.state = {
      numberGrade,
      description
    }
  }
  //
  render() {
    return <div styleName='grade-snapshot'>
      <div styleName='grade-intro'>
        <div styleName='grade-intro-description'>
          <strong>Prison industrial complex grade:</strong> {this.state.description}
        </div>
        <div styleName='grade-intro-link'>
          <Link
            strong
            to={config.routes.howitworks}
            title='How it works'
          >
            <strong>How we track investments in the prison industrial
            complex<LinkIcon /></strong>
          </Link>
        </div>
      </div>
      <div styleName='grade-wrapper'>
        <Grade grade={this.state.numberGrade} large />
      </div>
    </div>
  }
}


/*
 * BUTTONS
 *
 * HAS MORE COMPANIES TO SHOW? SHOW MORE BUTTON
 */
@CSSModules(Styles, {allowMultiple:true})
class HasMoreCompaniesButton extends Component {
  static propTypes = {
    page: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    increment: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    const showButton = (props.page === 1 && props.count > FirstPage)

    this.state = {
      showButton
    }
  }

  render() {
    if (!this.state.showButton) return null

    return <div
      styleName={'detail-more-'+this.props.type}
      onClick={this.props.increment('pffPage') }
    >
      See all<LinkIcon faclass='fa-angle-down'/>
    </div>
  }
}

/*
 * BUTTON TO SHORE MORE INFO ABOUT THE FUND
 */
@CSSModules(Styles, {allowMultiple:true})
class ShowMoreFundInfoButton extends Component {
  static propTypes = {
    viewMore: PropTypes.bool.isRequired,
    clickViewMore: PropTypes.func.isRequired
  }

  render() {
    return <div styleName='view-more-wrapper'>
      <button
        styleName='view-more'
        title='More fund info'
        onClick={this.props.clickViewMore}
      >
       More fund info
        <LinkIcon
          faclass={this.props.viewMore ? 'fa-angle-up' : 'fa-angle-down'}
        />
      </button>
    </div>
  }
}


/*
 * TODO:
 * STAT COLUMN FOR "MORE FUND INFO" SECTION
 * EACH COLUMN IS A <COL> WITH XS={6}
 */
// @CSSModules(Styles, {allowMultiple:true})
// class FundStatColumn extends Component {
//   static propTypes = {
//     type: PropTypes.string.isRequired,
//     entries: PropTypes.array.isRequired,
//     hasLine: PropTypes.bool.isRequired,
//   }

//   render() {
//     return <Col xs={6} styleName={'col-'+this.props.type+'-wrapper'}>
//       {
//         this.props.entries.map((entry, i) => {
//           return <div
//             key={i}
//             styleName='col-label-value'
//           >
//             <div styleName={'col-'+this.props.type}>
//               <div styleName='stats-label'>{entry.name}</div>
//               {
//                 entry.link ?
//                   <Link
//                     to={entry.link}
//                     title={entry.value}
//                   >
//                     <div styleName='stats-value-link'>{entry.value}</div>
//                   </Link> :
//                   <div styleName='stats-value'>{entry.value}</div>
//               }
//             </div>
//             {
//               this.props.hasLine && (i !== this.props.entries.length -1 ) ?
//                 <div styleName='col-line'/> :
//                 null
//             }
//           </div>
//         })
//       }
//     </Col>
//   }
// }


@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error,
  }),
  searchActions)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId))
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundPrisonInvestments extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      pffPage: 1,
      activeSector: '',
      viewMore: false,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    // window.addEventListener('scroll', this.handleScroll)
    analytics.event(analytics.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId))
  }

  getChartData = (fund, holdings, fHoldingsMap, label) => {
    // colors
    const colors = {
      'pp':'#313131',
      'pp_end':'#313131',
      'borders':'#313131',
      'borders_end':'#313131',
      'pff':'#313131',
      'pff_lite':'#313131',
      'gray':'#D5D5D5',
      'red':'#C3001C',
      'orange':'#F2961C',
      'yellow':'#DFB553',
      'black':'#313131'
    }

    // const allCount = 'pff_all_count'
    // const allAsset = 'pff_all_asset'
    // const allWeight = 'pff_all_weight'
    // const allRating = 'grade_prison_industrial_complex'

    // what categories are active?
    const activeSector = this.state.activeSector

    const allAsset = convert.int(fund.pff_all_asset)
    const allWeight = convert.float(fund.pff_all_weight)
    const allWeightFmt = format.perc(allWeight)
    const fundRating = convert.float(fund.grade_prison_industrial_complex)
    const capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1)
    let chartData = []

    if (activeSector && allAsset > 0) {
      // companies
      const num_colors = convert.int(fund[activeSector+'_count'])
      const scaleStart = colors[activeSector]
      let scaleEnd = colors[activeSector+'_end']
      if (holdings.length === 1) {
        scaleEnd = scaleStart
      }
      const f = chroma.scale([scaleStart,scaleEnd]).mode('rgb').colors(num_colors)
      // const shuffled = format.shuffle(f)
      let currIdx = -1
      // // map holdings to pie chart data
      chartData = holdings.reduce( (filtered, holding) => {
        const nameLabel = format.longString(holding.security_name, 20)
        const moneyLabel = format.money(fHoldingsMap[holding.id].market_value, true, 'USD', true)
        currIdx = (currIdx + 1) % num_colors
        filtered.push({
          value: fHoldingsMap[holding.id].market_value,
          label: nameLabel + ' ' + moneyLabel,
          color: f[currIdx]
        })
        return filtered
      }, [])
    } else {
      if (allAsset > 0) {
        chartData = [
          {
            value: allAsset,
            label: allWeightFmt + ' flagged',
            color: colors.black
          }
        ]
        chartData.push(
          {
            value: convert.int(fund.fund_net_assets) - allAsset,
            label: 'All other holdings',
            color: colors.gray
          }
        )
      } else {
        chartData = [{
          value: 1,
          label: 'No ' + label + ' stock holdings',
          color: colors.gray
        }]
      }
    }
    return chartData
  }

  clickViewMore = () =>{
    this.setState({viewMore: !this.state.viewMore})
  }

  clickSector(newSector){
    this.setState({
      activeSector: (newSector === this.state.activeSector) ? '' : newSector,
      pffPage: 1
    })
  }

  increment = (incState) => {
    return () => {
      const newState = {}
      newState[incState] = this.state[incState] + 1
      this.setState(newState)
    }
  }

  formatHoldingsCount = (count) => {
    if (count > 0) {
      return format.number(count) + ' holdings'
    }
    //
    return ''
  }

  /*
   * RENDER FUNCTIONS BELOW SHOULD BE BROKEN OUT INTO COMPONENTS
   *
   */
  renderSectors = (sector, fund, shareClass, fHoldingsMap) => {
    return <div key={sector[0]}>
      { /* render the sector switch */
        this.renderSectorDetailsSwitch(
          sector[0],
          sector[1],
          sector[2],
          fund[sector[3]],
          fund[sector[4]],
          fund[sector[5]],
          shareClass.currency
        )
      }
      <SlideDown>
        { /* render the holding list if the sector is active */
          this.state.activeSector === sector[0] ?
            this.renderHoldingsTable(
              shareClass,
              fHoldingsMap,
              sector[0],
              sector[1],
              shareClass[sector[3]],
              sector[6],
              this.state.pffPage
            ) :
            null
        }
      </SlideDown>
    </div>
  }

  renderSectorDetailsSwitch = (type, label, sublabel, count, weight, asset, currency) => {
    // circle icon
    const iconNormal = require( '../../../static/images/icn-'+type+'.svg' )
    // circle icon filled in
    const iconActive = require( '../../../static/images/icn-'+type+'-active.svg' )
    // circle icon with green slash
    const iconClean = require( '../../../static/images/icn-'+type+'-inactive-slash.svg' )
    // clean or dirty?
    const isDirty = (convert.int(count))
    // currently active?
    const isActive = (type===this.state.activeSector)
    // what style?
    let currIcon = null
    let cleanDirtyStyle = ''

    if (isDirty) {
      if (isActive){
        cleanDirtyStyle = 'detail-sector-'+type+'-active'
        currIcon = iconActive
      } else {
        cleanDirtyStyle = 'detail-sector-'+type+'-normal'
        currIcon = iconNormal
      }
    } else {
      cleanDirtyStyle = 'detail-sector-clean'
      currIcon = iconClean
    }

    const clickSectorFn = (sectorType) => {
      if (isDirty) {
        this.clickSector(sectorType)
      }
    }

    return (
      <div
        styleName='detail-sector-wrapper'
        onClick={ () => clickSectorFn(type) }>
        <div styleName={cleanDirtyStyle}>
          <div styleName='detail-sector-detail-icon-wrap'>
            <img
              styleName='detail-icon'
              src={currIcon}
              alt={label}
            />
          </div>
          <div styleName='detail-title-active'>
            <div>{label}</div>
            {
              sublabel ?
                (
                  <div styleName='detail-sublabel'>{sublabel}</div>
                ) :
                null
            }
          </div>
          {
            isDirty ?
              (
                <div styleName='detail-sector-stat-wrapper'>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.number(count)}
                    </div>
                    <div styleName='detail-stat-label'>holdings</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.money(asset, true, currency, true)}
                    </div>
                    <div styleName='detail-stat-label'>invested</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.perc(weight)}
                    </div>
                    <div styleName='detail-stat-label'>of portfolio</div>
                  </div>
                </div>
              ) :
              (
                <div styleName='single-badge-wrap'>
                  <div styleName='single-badge-text'>
                    <div styleName='single-badge-title'>
                      0 direct stock holdings
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>
    )
  }

  renderHoldingsTable = (shareClass, fHoldingsMap, type, label, count, holdings, page) => {
    count = convert.int(count)

    if (count === 0) { return null }

    //
    return <Col xs={12} styleName='detail-holdings-wrapper'>
      <div styleName={'detail-prisons'}>
        <div styleName='detail-title-holdings'>
          <div styleName={'detail-title-'+type}>
            {label}
          </div>
          <div
            styleName={'visible-sm visible-md visible-lg detail-holdings-count-'+type}
          >
            {this.formatHoldingsCount(count)}
          </div>
        </div>
        <div styleName={'visible-xs mobile-holdings-label'}>
          {count} holdings
        </div>
        <ul styleName='detail-holdings'>
          {this.renderHoldingsTableRows(shareClass, fHoldingsMap, holdings, page)}
        </ul>
        <div styleName='detail-holdings-info-text'>
          <HighRiskIcon /> <em>Higher risk</em>
          <br/>
          <ExtremeRiskIcon /> <em>Private prison operator</em>
        </div>
      </div>
      <HasMoreCompaniesButton 
        page={page}
        count={count}
        type={type}
        increment={this.increment}
      />
    </Col>
  }

  renderHoldingsTableRows = (shareClass, fHoldingsMap, holdings, page) => {
    if( !holdings || holdings.length === 0 ){
      return ( <div styleName='holdings-none'>NONE</div> )
    }

    const takeCount = (page > 1) ? AllPage : FirstPage

    const iconPp = require( '../../../static/images/icn-pp-no-circle-black.svg' )
    const iconBorders = require( '../../../static/images/icn-borders-no-circle-black.svg' )

    const iconConfigs = [
      ['is_pp', iconPp, 'Prison industry'],
      ['is_borders', iconBorders, 'Border industry'],
    ]
    //
    return chain(holdings)
      .take(takeCount)
      .map((h, idx) =>{
        const isHigh = h.is_pff_high
        const isExtreme = h.is_pff_extreme
        const fPerc = format.perc(fHoldingsMap[h.id].long_weight)
        const fMoney = format.money(
          fHoldingsMap[h.id].market_value,
          true,
          shareClass.currency,
          true
        )
        let holdingClass = 'holding '
        if (isExtreme) { 
          holdingClass += 'holding-extreme'
        } else if (isHigh) {
          holdingClass += 'holding-high' 
        }
        //
        return <li key={idx}>
          <CompanyProfileModal companyId={h.company_id}>
            <div styleName={holdingClass}>
              <div styleName='holding-name-wrap'>
                <span styleName='holding-modal-open-icon'>
                  <LinkIcon faclass='fa-angle-right' />
                </span>
                {idx + 1}.
                &nbsp;
                {
                  isHigh ?
                    isExtreme ?
                      <div styleName='holding-name-extreme'>
                        <ExtremeRiskIcon />
                        &nbsp;
                        {h.security_name}
                      </div> :
                      <div styleName='holding-name-high'>
                        <HighRiskIcon />
                        &nbsp;
                        {h.security_name}
                      </div> :
                    <div styleName='holding-name'>
                      {h.security_name}
                    </div>
                }
              </div>
              <div styleName='holding-figures'>
                <div>
                  { /* mini-sector icons */
                    iconConfigs.map((sector)=>{
                      return <span
                        key={sector[0]}
                        title={sector[2]}
                      >
                        { 
                          h[sector[0]] ? 
                            <img
                              styleName='detail-icon-holding'
                              src={sector[1]}
                              alt={sector[2]}
                            /> :
                            <div styleName='detail-icon-holding' />
                        }
                      </span>
                    })
                  }
                </div>
                <div styleName='holding-invested'>
                  {fMoney}
                </div>
                <div styleName='holding-asset'>
                  {fPerc}
                </div>
              </div>
            </div>
          </CompanyProfileModal>
        </li>
      })
      .value()
  }

  renderMoreFundInfo = (shareClass,showDataAs) => {
    return (
      <div styleName='more-stats'>
        <ShowMoreFundInfoButton
          viewMore={this.state.viewMore}
          clickViewMore={this.clickViewMore}
        />
        <SlideDown>
          { this.state.viewMore ? this.renderStats(shareClass) : null }
        </SlideDown>
      </div>
      )
  }

  renderStats = (shareClass) => {
    /*
     * TODO:
     * DEPRECATE THIS AND REFACTOR AS COMPONENT
     */
    function renderCol(type, entries, hasLine) {
      return <Col xs={6} styleName={'col-'+type+'-wrapper'}>
        {
          entries.map((entry,idx) => {
            return <div
              key={idx}
              styleName='col-label-value'
            >
              <div styleName={'col-'+type}>
                <div styleName='stats-label'>{entry.name}</div>
                {
                  entry.link ? <Link
                    to={entry.link}
                    title={entry.value}
                  >
                    <div styleName='stats-value-link'>{entry.value}</div>
                  </Link> :
                  <div styleName='stats-value'>{entry.value}</div>
                }
              </div>
              {
                hasLine && (idx !== entries.length-1) ?
                  <div styleName='col-line'/> :
                  null
              }
            </div>
          })
        }
      </Col>
    }

    const dest = encodeURIComponent(shareClass.fund_family_name)

    return (
      <div styleName='stats'>
        <div styleName='stats-inner'>
          <Row styleName='stats-header'>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div styleName='stats-title'>
                Mutual fund investment profile
              </div>
            </Col>
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol('left', [{name: 'Shareclass ticker', value:shareClass.ticker}], false) }
            { renderCol('right', [{name: 'Data as of', value:moment(shareClass.date.slice(0,10)).format('D MMM YYYY')}], false) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol('left', [{name: 'Shareclass name', value:shareClass.name}], false) }
            { renderCol('right', [{name: '% of fund assets screened', value:format.perc(shareClass.percent_rated) }], false) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol('left', [{name: 'Shareclass type', value:format.legalType(shareClass.legal_type)}], false) }
            { renderCol('right', [{name: 'Fund net assets', value:format.money(shareClass.fund_net_assets, true, shareClass.currency)}], false) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol('left', [{name: 'Fund family', link:config.routes.families+'?q='+dest, value:shareClass.fund_family_name}], false) }
            { renderCol('right', [{name: 'Fund category', value:shareClass.category_group }], false) }
          </Row>
          <div styleName='line'/>
          { /* <Row>
            { renderCol('left', [{name: 'Domicile country', value:format.market(shareClass.market)}], false) }
            { renderCol('right', [{name: 'Portfolio currency', value:format.currencyCode(shareClass.currency)}], false) }
          </Row> */ }
          <Row>
            { renderCol('left', [{name: 'Sustainable investment', value: format.boolean(shareClass.ussif || "0")}], false) }
            { renderCol('right', [{name: '', value: ''}], false) }
          </Row>
          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Prison industrial complex summary results
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Prison industrial complex grade</div>
              <div styleName='profile-grade-title'>
                <Grade grade={shareClass.grade_prison_industrial_complex}/>
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Prison industrial complex holdings</div>
              <div styleName='stats-total-value'>{ format.number(shareClass.pff_all_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>% invested in prison industrial complex stocks</div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.pff_all_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Assets invested in prison industrial complex stocks</div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.pff_all_asset, true, shareClass.currency, false) }
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Prison industrial complex holdings, <strong>higher risk</strong></div>
              <div styleName='stats-total-value'>{ format.number(shareClass.pff_all_high_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>% invested in prison industrial complex stocks, <strong>higher risk</strong></div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.pff_all_high_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Assets invested in prison industrial complex stocks, <strong>higher risk</strong></div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.pff_all_high_asset, true, shareClass.currency, false) }
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Prison industrial complex holdings, <span styleName='bred'>private prison operators</span></div>
              <div styleName='stats-total-value'>{ format.number(shareClass.pff_all_extreme_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>% invested in prison industrial complex stocks, <span styleName='bred'>private prison operators</span></div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.pff_all_extreme_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Assets invested in prison industrial complex stocks, <span styleName='bred'>private prison operators</span></div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.pff_all_extreme_asset, true, shareClass.currency, false) }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }


  //
  render() {
    if (!this.props.result) {
      return <LoadingIcon />
    } else if (
      this.props.result && 
      (
        !this.props.result.fund ||
        !this.props.result.shareClass
      )
    ) {
      this.context.router.push(config.routes.notFound)
      return <LoadingIcon />
    }

    const shareClass = this.props.result.shareClass
    const title = shareClass.fund_legal_name + ' | Prison industrial complex investments'
    const fund = this.props.result.fund
    const ticker = shareClass.ticker ? shareClass.ticker : 'N'
    const name = format.sanitize(shareClass.fund_legal_name)
    const urlStart = config.routes.fund+'/'+name+'/'+ticker
    const urlEnd = shareClass.fund_id+'/'+shareClass.investment_vehicle_id
    const url = config.domain+urlStart+'/prison-industrial-complex-investments/'+urlEnd

    // could this be cached (e.g. in state) to improve performance?
    const fHoldingsMap = mapFundHoldings(this.props.result.fund.fundholdings)
    const cids = {
      coreCivic: 'C_h9wkEMcZ',
      geoGroup: 'C_SWNN6bWg',
      // g4s: '0C00000NVK',
      sodexo: 'C_zvW7w5DC',
      serco: 'C_vVHSP2XU',
      mitie: 'C_vAUW9xc0',
      ferrovial: 'C_hFpoMOz2',
    }
    const owns = {}
    const cidNames = Object.keys(cids)
    for (let i = 0; i < cidNames.length; i++) {
      owns[cidNames[i]] = false
    }
    const pffHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      for (let i = 0; i < cidNames.length; i++) {
        if (o.company_id === cids[cidNames[i]]) {
          owns[cidNames[i]] = true
        }
      }
      return (o.is_pp  ||
              o.is_borders)
    })
    const ppHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return (o.is_pp)
    })
    const bordersHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return (o.is_borders)
    })

    const allHoldings = pffHoldings
    const chartMessage = 'Prison industrial complex'
    const label = 'flagged'
    // const capitalizedLabel = label.charAt(0).toUpperCase() + label.slice(1)
    const activeLabel = 'Prison industrial complex'
    const allCount = 'pff_all_count'
    const allAsset = 'pff_all_asset'
    const allWeight = 'pff_all_weight'
    const allRating = 'grade_prison_industrial_complex'

    // LOGOS OF MOST EXTREME PRIVATE PRISON OPERATORS
    const coreCivicIcon = require( '../../../static/images/CoreCivic-gray.png' )
    const geoGroupIcon = require( '../../../static/images/GEOGroup-gray.png' )
    const sodexoIcon = require( '../../../static/images/Sodexo-gray.png' )
    const sercoIcon = require( '../../../static/images/Serco-gray.png' )
    const ferrovialIcon = require( '../../../static/images/Ferrovial-gray.png' )
    const mitieIcon = require( '../../../static/images/Mitie-gray.png' )
    const g4sIcon = require( '../../../static/images/G4S-gray.png' )
    const extremeCompanyLogosConfig = [
      ['coreCivic', coreCivicIcon, 'CoreCivic'],
      ['geoGroup', geoGroupIcon, 'GeoGroup'],
      ['sodexo', sodexoIcon, 'Sodexo'],
      ['serco', sercoIcon, 'Serco'],
      ['mitie', mitieIcon, 'MITIE Group'],
      ['g4s', g4sIcon, 'G4S'],
      ['ferrovial', ferrovialIcon, 'Ferrovial'],
    ]

    // simple aliases
    const a = format.money(shareClass.pff_all_asset, true, 'USD', true, 2)
    const b = format.perc(shareClass.pff_all_weight)
    const c = format.money(shareClass.pff_all_high_asset, true, 'USD', true, 2)
    const d = format.perc(shareClass.pff_all_high_weight)
    const e = format.money(shareClass.pff_all_extreme_asset, true, 'USD', true, 2)
    const f = format.perc(shareClass.pff_all_extreme_weight)

    return <div>
      {container.helmet(title, '', url)}

      <FundName
        shareClass={shareClass}
        pathname={this.props.location.pathname}
      />

      <div styleName='main'>
        <ContainerDivs>
          
          <Row>

            { /* LEFT COLUMN */ }
            <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>

              <PrisonGradeBox fund={fund}/>

              { /* IF NO SECTOR HAS BEEN SELECTED */
                (
                  this.state.activeSector==='' &&
                  convert.int(fund.pff_all_asset) > 0
                ) ?
                  <Chart
                    currency={shareClass.currency}
                    invested={convert.int(fund.pff_all_asset)}
                    chartData={
                      this.getChartData(
                        fund,
                        allHoldings,
                        fHoldingsMap,
                        label
                      )
                    }
                    chartMessage={chartMessage}
                  /> :
                  null
              }

              { /* IF NO PRISONS SECTOR HAS BEEN SELECTED */
                (
                  this.state.activeSector==='pp' &&
                  convert.int(fund.pff_all_asset) > 0
                ) ?
                  <Chart
                    currency={shareClass.currency}
                    invested={convert.int(fund.pp_asset)}
                    chartData={
                      this.getChartData(
                        fund,
                        ppHoldings,
                        fHoldingsMap,
                        label
                      )
                    }
                    chartMessage='Prison industry'
                  /> :
                  null
              }

              { /* IF NO BORDERS SECTOR HAS BEEN SELECTED */
                (
                  this.state.activeSector==='borders' &&
                  convert.int(fund.pff_all_asset)>0
                ) ?
                  <Chart
                    currency={shareClass.currency}
                    invested={convert.int(fund.borders_asset)}
                    chartData={
                      this.getChartData(
                        fund,
                        bordersHoldings,
                        fHoldingsMap,
                        label
                      )
                    }
                    chartMessage='Border industry'
                  /> :
                  null
              }

              <FlaggedFund
                count={convert.int(fund.pff_all_count)}
                weight={convert.float(fund.pff_all_weight)}
                asset={convert.int(fund.pff_all_asset)}
                portfolioDate={fund.date}
                label={label}
              />

            </Col>

            { /* RIGHT COLUMN */ }
            <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>

              {
                convert.int(fund.pff_all_count)===0 ?
                  <NoFlaggedHoldingsAlert /> :
                  null
              }

              <FlaggedHoldingsAlert
                a={a}
                b={b}
                c={c}
                d={d}
                e={e}
                f={f}
              />

              { /* FLAGGED HOLDING ALERTS
                convert.int(fund.pff_all_count)===0 ?
                  <NoFlaggedHoldingsAlert /> :
                  <FlaggedHoldingsAlert
                    a={a}
                    b={b}
                    c={c}
                    d={d}
                    e={e}
                    f={f}
                  />
              */ }

              { /* SECTION TO DISPLAY LOGOS OF ANY EXTREME HOLDINGS */
                convert.int(fund.pff_all_extreme_count) ?
                  <div>
                    <div styleName='extreme-logo-subtitle'>
                      Private prison operator holdings
                    </div>
                    <div styleName='extreme-logo-wrap'>
                      { /* CHECK TO SEE IF EACH EXTREME COMPANY IS OWNED
                           IF SO, RENDER A LOGO */
                        extremeCompanyLogosConfig.map((e, i) => {
                          return owns[e[0]] ?
                            <img
                              key={'extreme-company-logo-'+i}
                              styleName='extreme-logo'
                              src={e[1]}
                              alt={e[2]} 
                            /> :
                            null
                        })
                      }
                    </div>
                  </div> :
                  null
              }

              <div>
                <div styleName='sector-details-info'>
                  Click to see the breakdown of flagged holdings.
                </div>
                { /* Sector switches + company lists */
                  [
                    [
                      'pp',
                      'Prison industry',
                      'Incarceration and detention facilities, ' +
                        'services in facilities, supervision and ' +
                        'monitoring',
                      'pp_count',
                      'pp_weight',
                      'pp_asset',
                      ppHoldings
                    ],
                    [
                      'borders',
                      'Border industry',
                      'Incarceration and detention facilities, ' +
                        'immigrant monitoring and surveillance, ' +
                        'militarization of the U.S.-Mexico border',
                      'borders_count',
                      'borders_weight',
                      'borders_asset',
                      bordersHoldings
                    ]
                  ]
                  .map((sector)=>{
                    return this.renderSectors(
                      sector,
                      fund,
                      shareClass,
                      fHoldingsMap
                    )
                  })
                }
              </div>

              {
                convert.int(fund.pff_all_count) ?
                  <div>
                    <SlideDown>
                      {
                        this.state.activeSector === '' ?
                          this.renderHoldingsTable(
                            shareClass,
                            fHoldingsMap,
                            'pff',
                            'All flagged holdings',
                            shareClass.pff_all_count,
                            allHoldings,
                            this.state.pffPage
                          ) :
                          null
                      }
                    </SlideDown>
                  </div> :
                  <ToolkitAlert />
              }
            </Col>
          </Row>

          {this.renderMoreFundInfo(shareClass)}

          <InlineSignup />

        </ContainerDivs>
      </div>

      <IyvScorecard fund={fund} shareClass={shareClass} />

      <FundShareTakeAction
        fund={fund}
        shareClass={shareClass}
        url={url}
        screen={this.state.screen}
      />
    </div>
  }
}
